import { ValidationResult } from 'joi';

import { ValidationFunctionResult } from '../../../../shared/types/validation-function-result';
import { CreateTransactionDto } from '../../dtos/create-transaction.dto';
import { UpdateTransactionDto } from '../../dtos/update-transaction.dto';
import { createTransactionSchema } from '../schemas/create-transaction.schema';
import { updateTransactionSchema } from '../schemas/update-transaction.schema';

/**
 * Validates record data for creation or update.
 * @param record - The record to validate.
 * @param abortEarly - Whether to abort the validation on the first error.
 * @returns The validation result.
 */
export const canCreateOrUpdate = (
	record: CreateTransactionDto | UpdateTransactionDto,
	abortEarly: boolean = false,
): ValidationFunctionResult => {
	// Check if record is provided
	if (!record) throw new Error('record is required.');

	let validationResult: ValidationResult | undefined;

	// Determine if it's an update or create operation by checking for 'id'
	if ('id' in record && record.id) {
		// Validate against updateTransactionSchema if 'id' is present
		validationResult = updateTransactionSchema().validate(record, {
			abortEarly,
		});
	} else {
		// Validate against createTransactionSchema if 'id' is not present
		validationResult = createTransactionSchema().validate(record, {
			abortEarly,
		});
	}

	// Check for validation errors
	if (validationResult?.error) {
		return {
			isValid: false,
			errors: validationResult.error.details?.map((e) => e.message),
		};
	}

	// Return valid result if no errors
	return { isValid: true };
};
